// IMPORT COMPONENTS
import $ from "jquery";
import BaseAccordion from "../base-accordion/base-accordion";
export default class FaqAccordion extends BaseAccordion {
  init() {
    super.init();
    this.gotTo();

    window.addEventListener(
      "hashchange",
      () => {
        this.gotTo();
      },
      false
    );
  }

  gotTo() {
    const anchor = document.location.href.split("#")[1];
    const $collapse = $("div[id^='collapse-" + anchor + "']");
    //const $collapse= $(`#collapse-${anchor}`);
    if ($collapse && $collapse.length > 0) {
      $collapse.collapse("show");
      setTimeout(() => {
        $("html, body").animate(
          {
            scrollTop: $(`#${anchor}`).offset().top - $(".header").height()
          },
          300,
          function() {
            $(document).trigger("refreshStickyBar");
          }
        );
      }, 300);
    }
  }
}
